import React from 'react';
import styles from './DataLakeSettingsTab.module.css';
import ToggleSwitch from '../../../ui/ToggleSwitch/ToggleSwitch';
import { FieldRenderProps } from './types';
import KeyIndicator from './KeyIndicator';

const ToggleRow: React.FC<FieldRenderProps & { big?: boolean }> = ({ field, draft, initialDraft, showKeys, highlighted, saving, onToggle, big }) => {
  const disabled = !!field.dependsOn && draft[field.dependsOn] !== 'true';
  const checked = draft[field.key] === 'true';
  const isModified = draft[field.key] !== (initialDraft[field.key] ?? '');
  return (
    <div className={`${styles.toggleRow} ${big ? styles.toggleRowHeader : ''} ${disabled ? styles.cardDisabled : ''} ${highlighted ? styles.cardHighlight : ''}`}>
      <div className={styles.toggleInfo}>
        <p className={styles.toggleLabel}>
          {field.label}
          <KeyIndicator field={field} showKeys={showKeys} />
          {isModified && <span className={styles.modifiedBadge}>Modified</span>}
        </p>
        <p className={styles.toggleDescription}>{field.description}</p>
        {disabled && field.dependsOn && (
          <p className={styles.disabledNote}>{field.disabledNote ?? 'Disabled while the setting above is off.'}</p>
        )}
      </div>
      <ToggleSwitch checked={checked} onChange={() => onToggle(field.key)} disabled={disabled || saving} />
    </div>
  );
};

export default ToggleRow;
